export default __webpack_public_path__ + "static/media/icon_search.8b27d249.svg";